import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStrikethrough = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M4.75 12.25h14.5M18.25 8.25V8a3 3 0 0 0-3-3h-6.5a3 3 0 0 0-3 3v1.25a3 3 0 0 0 3 3H15M5.75 15.75v.5a3 3 0 0 0 3 3h6.5a3 3 0 0 0 3-3v-1.5"
    />
  </svg>
);
export default SvgStrikethrough;
